<div
    class="extern-tierarzt-details"
    [class.extern-tierarzt-details--with-meine]="meineTieraerzte?.length > 0"
    [class.extern-tierarzt-details--with-selection]="hasSelection()"
    [class.extern-tierarzt-details--edit]="editMode"
>
    <div class="details-body" [class.details-body--split]="useSplitLayout()">
        <section
            *ngIf="hasSelection()"
            class="selection-card"
            [class.selection-card--compact]="editMode && allowChange"
            aria-live="polite"
        >
            <div class="selection-card__header">
                <div class="selection-card__status" aria-hidden="true">
                    <mat-icon>check_circle</mat-icon>
                </div>
                <div class="selection-card__title">
                    <span class="selection-card__label">Ausgewählt</span>
                    <strong class="selection-card__name">{{ displayValue(externTierarzt?.name) }}</strong>
                </div>
                <button
                    *ngIf="showChangeButton()"
                    type="button"
                    mat-stroked-button
                    color="accent"
                    class="selection-card__change"
                    (click)="clearSelection()"
                >
                    Ändern
                </button>
            </div>
            <div class="selection-card__grid">
                <div class="selection-card__field">
                    <span class="selection-card__field-label">Straße</span>
                    <span class="selection-card__field-value">{{ displayValue(externTierarzt?.strasse) }}</span>
                </div>
                <div class="selection-card__field">
                    <span class="selection-card__field-label">PLZ / Ort</span>
                    <span class="selection-card__field-value">{{ displayPlzOrt() }}</span>
                </div>
                <div class="selection-card__field">
                    <span class="selection-card__field-label">Telefon</span>
                    <span class="selection-card__field-value">{{ displayValue(externTierarzt?.telefon) }}</span>
                </div>
                <div class="selection-card__field">
                    <span class="selection-card__field-label">Fax</span>
                    <span class="selection-card__field-value">{{ displayValue(externTierarzt?.fax) }}</span>
                </div>
                <div class="selection-card__field selection-card__field--full">
                    <span class="selection-card__field-label">E-Mail</span>
                    <span class="selection-card__field-value">{{ displayValue(externTierarzt?.email) }}</span>
                </div>
            </div>
        </section>

        <div class="details-picker">
            <section *ngIf="showMeineSection()" class="section section--meine">
                <div class="section-heading">
                    <h3 class="section-title">
                        <mat-icon aria-hidden="true">bookmark</mat-icon>
                        Meine Tierärzte
                    </h3>
                    <span *ngIf="!isLoadingMeine && meineTieraerzte.length" class="section-heading__count">
                        {{ meineTieraerzte.length }}
                    </span>
                </div>

                <mat-form-field *ngIf="showMeineFilter()" class="meine-filter full-width" appearance="outline">
                    <mat-label>Tierarzt filtern</mat-label>
                    <input matInput type="search" [(ngModel)]="meineFilter" autocomplete="off" />
                    <button
                        *ngIf="meineFilter"
                        type="button"
                        mat-icon-button
                        matSuffix
                        aria-label="Filter zurücksetzen"
                        (click)="meineFilter = ''"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                    <mat-icon *ngIf="!meineFilter" matSuffix aria-hidden="true">search</mat-icon>
                </mat-form-field>

                <div *ngIf="isLoadingMeine" class="meine-loading" aria-busy="true">
                    <mat-icon aria-hidden="true">hourglass_empty</mat-icon>
                    <span>Tierärzte werden geladen …</span>
                </div>

                <div
                    *ngIf="!isLoadingMeine"
                    class="meine-list-panel"
                    role="listbox"
                    aria-label="Meine Tierärzte"
                >
                    <button
                        type="button"
                        role="option"
                        class="meine-list-item"
                        *ngFor="let t of filteredMeineTieraerzte(); trackBy: trackByExternTierarztId"
                        [class.meine-list-item--selected]="externTierarzt?.extern_tierarzt_id === t.extern_tierarzt_id"
                        [attr.aria-selected]="externTierarzt?.extern_tierarzt_id === t.extern_tierarzt_id"
                        (click)="selectFromMeine(t)"
                    >
                        <span class="meine-list-item__avatar" aria-hidden="true">
                            <mat-icon>person</mat-icon>
                        </span>
                        <span class="meine-list-item__body">
                            <span class="meine-list-item__name">{{ t.name }}</span>
                            <span *ngIf="displayMeineSubtitle(t) as subtitle" class="meine-list-item__meta">{{
                                subtitle
                            }}</span>
                        </span>
                        <mat-icon
                            *ngIf="externTierarzt?.extern_tierarzt_id === t.extern_tierarzt_id"
                            class="meine-list-item__check"
                            aria-hidden="true"
                        >
                            check_circle
                        </mat-icon>
                    </button>

                    <p *ngIf="meineTieraerzte.length && !filteredMeineTieraerzte().length" class="meine-list-empty">
                        Kein Tierarzt entspricht Ihrer Suche.
                    </p>
                </div>
            </section>

            <section *ngIf="showSearch()" class="section section--search">
                <h3 class="section-title">
                    <mat-icon aria-hidden="true">search</mat-icon>
                    Suchen oder neu anlegen
                </h3>
                <div class="autocomplete-container">
                    <kiene-autocomplete
                        #nameAutocomplete
                        (elementSelected)="selectedTierarzt($event)"
                        [displayFields]="['name', 'ort']"
                        [separator]="', '"
                        [emitFreeText]="false"
                        [createNewAllowed]="true"
                        [createNewText]="'Neuen Tierarzt anlegen'"
                        (createNew)="createNewExternTierarzt($event)"
                        [focus]="false"
                        [genericApiUrl]="tierarztPath"
                        [multiLine]="false"
                        [panelWidth]="autocompletePanelWidth()"
                        [placeholder]="'Name des Tierarztes'"
                        [required]="false"
                        [showClear]="true"
                        [showLoadingIndicator]="true"
                        class="full-width"
                    >
                    </kiene-autocomplete>
                </div>
            </section>
        </div>
    </div>

    <div *ngIf="!hasSelection() && !meineTieraerzte?.length && !isLoadingMeine" class="empty-hint">
        <mat-icon aria-hidden="true">info</mat-icon>
        <span>Noch keine Tierärzte gespeichert. Nutzen Sie die Suche, um den ersten Tierarzt anzulegen.</span>
    </div>
</div>
